<div class="productPage" [class.salesWorkspace]="selectedTabIndex === 4">
  <ng-container *ngIf="product as currentProduct; else loadingState">
    <header class="pageHeader" [class.compactHeader]="mainInfoCollapsed">
      <div class="identitySummary">
        <div class="productThumbnail" *ngIf="mainInfoCollapsed">
          <button
            *ngIf="primaryImage as compactImage; else noCompactPhoto"
            type="button"
            class="thumbnailButton"
            aria-label="Открыть фото товара"
            (click)="productGallery.select(compactImage); productGallery.openPhotoViewer()"
          >
            <img [src]="productGallery.getImageUrl(compactImage)" [alt]="currentProduct.description || 'Фото товара'" />
          </button>
          <ng-template #noCompactPhoto>
            <div class="thumbnailPlaceholder"><mat-icon>photo_camera</mat-icon><span>Нет фото</span></div>
          </ng-template>
        </div>
        <div class="productIdentity">
          <h1 [title]="productForm.controls.description.value || 'Без названия'">{{ productForm.controls.description.value || 'Без названия' }}</h1>
          <div class="productMeta">
            <strong>{{ brandControl.value?.description }}</strong>
            <span>{{ productForm.controls.article.value }}</span>
            <span class="productId">ID {{ currentProduct.id }}</span>
            <span class="unsavedBadge" *ngIf="productForm.dirty">Есть изменения</span>
          </div>
          <div class="productStats headerStats" aria-label="Сводка по товару">
            <button class="statChip stockChip" type="button" (click)="selectWorkspaceTab(0)">
              <mat-icon>inventory_2</mat-icon><span>На складе</span><strong>{{ totalStock }}</strong>
            </button>
            <div class="statChip">
              <mat-icon>local_shipping</mat-icon><span>Поставщики</span><strong>{{ providerStockCount }}</strong>
            </div>
            <div class="statChip priceChip">
              <mat-icon>sell</mat-icon><strong>{{ productForm.controls.retail.value | number: '1.0-2' }} грн.</strong>
            </div>
          </div>
        </div>
      </div>

      <div class="headerActions">
        <button
          mat-stroked-button
          type="button"
          class="collapseButton"
          aria-controls="product-main-info"
          [attr.aria-expanded]="!mainInfoCollapsed"
          [attr.aria-label]="mainInfoCollapsed ? 'Развернуть основную информацию о товаре' : 'Свернуть основную информацию о товаре'"
          (click)="toggleMainInfo()"
        >
          <mat-icon>{{ mainInfoCollapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
          {{ mainInfoCollapsed ? 'Развернуть' : 'Свернуть' }}
        </button>
        <button
          mat-flat-button
          color="primary"
          class="saveButton"
          [disabled]="saving || importingFromExist"
          (click)="save()"
        >
          <mat-icon>save</mat-icon>
          {{ saving ? 'Сохранение…' : 'Сохранить' }}
        </button>
        <button
          mat-stroked-button
          class="moreButton"
          [matMenuTriggerFor]="productActions"
          [disabled]="saving || importingFromExist || enrichingWithAi"
          aria-label="Действия с товаром"
        >
          <mat-icon>more_horiz</mat-icon>
          <span>Действия</span>
        </button>
        <mat-menu #productActions="matMenu">
          <button mat-menu-item (click)="enrichWithAi()" [disabled]="enrichingWithAi">
            <mat-icon>auto_awesome</mat-icon>
            AI-наполнение
          </button>
          <button
            mat-menu-item
            [disabled]="importingFromExist || !currentProduct.article?.trim()"
            (click)="importFromExist()"
          >
            <mat-icon>download</mat-icon>
            Загрузить с Exist
          </button>
        </mat-menu>
      </div>
    </header>

    <section id="product-main-info" class="mainInfoPanel" [hidden]="mainInfoCollapsed" aria-label="Основная информация о товаре">
      <div class="galleryPanel">
        <app-gallery #productGallery [product]="currentProduct" (productChange)="updateGalleryProduct($event)"></app-gallery>
      </div>

      <form class="productForm compactFields" (ngSubmit)="save()" [formGroup]="productForm">
        <div class="nameFields">
          <mat-form-field appearance="outline">
            <mat-label>Наименование</mat-label>
            <textarea matInput rows="2" formControlName="description"></textarea>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Наименование укр</mat-label>
            <textarea matInput rows="2" formControlName="description_ua"></textarea>
          </mat-form-field>
        </div>

        <div class="commercialFields">
          <app-brand-selector [control]="brandControl" [loadOnFocus]="true"></app-brand-selector>
          <mat-form-field appearance="outline">
            <mat-label>Артикул</mat-label>
            <input matInput type="text" formControlName="article" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Розница, грн</mat-label>
            <input matInput type="number" formControlName="retail" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Фикс. наценка, %</mat-label>
            <input matInput type="number" min="0" step="0.01" formControlName="fixedMarkupPercent" />
          </mat-form-field>
          <app-provider-selector
            [control]="pricingProviderControl"
            [loadOnFocus]="true"
            [appearance]="'outline'"
            [label]="'Основной поставщик'"
          ></app-provider-selector>
        </div>

        <div class="formFooter">
          <div class="publicationFlags">
            <span>Публикация</span>
            <mat-checkbox formControlName="prom">Пром</mat-checkbox>
            <mat-checkbox formControlName="avtopro">Автопро</mat-checkbox>
          </div>
        </div>
        <button class="formSubmit" type="submit" tabindex="-1" aria-hidden="true"></button>
      </form>
    </section>

    <div class="operationStatus" *ngIf="importingFromExist || enrichingWithAi || loadingProduct" role="status">
      <mat-spinner diameter="16"></mat-spinner>
      {{ importingFromExist ? 'Загрузка с Exist…' : enrichingWithAi ? 'AI-наполнение…' : 'Обновление карточки…' }}
    </div>

    <section class="workspacePanel" aria-label="Данные товара">
      <mat-tab-group
        class="workspaceTabs"
        animationDuration="0ms"
        [preserveContent]="true"
        [selectedIndex]="selectedTabIndex"
        (selectedIndexChange)="selectWorkspaceTab($event)"
      >
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>warehouse</mat-icon><span>Наличие</span>
            <span class="tabCount">{{ totalStock }}</span>
          </ng-template>
          <ng-template matTabContent>
            <div class="workspacePane availabilityGrid">
              <section class="stockPane availabilitySection" aria-label="Наши склады">
                <div class="paneHeading"><h2>Наши склады</h2><span>Остатки, резервы и закупочные цены партий</span></div>
                <app-product-warehouse-table
                  [product]="currentProduct"
                  [minimumStockChanges]="minimumStockChanges"
                  (minimumStockSaved)="minimumStockSaved($event)"
                ></app-product-warehouse-table>
              </section>
              <section class="supplierPane availabilitySection" aria-label="Наличие у поставщиков">
                <div class="paneHeading"><h2>Поставщики <span class="tabCount">{{ providerStockCount }}</span></h2><span>Сначала в городе, затем по цене</span></div>
                <div class="supplierTableScroll" *ngIf="supplierGroups.length; else emptySuppliers"
                  tabindex="0" role="region" aria-label="Список предложений поставщиков">
                  <table class="supplierTable">
                    <caption>Цена и количество — по лучшему складу. Нажмите на поставщика, чтобы увидеть все склады.</caption>
                    <thead><tr><th scope="col">Поставщик</th><th scope="col">Наличие / город</th><th scope="col" class="numeric">Кол-во</th><th scope="col" class="numeric">Закупка, грн</th></tr></thead>
                    <tbody>
                      <ng-container *ngFor="let group of supplierGroups; trackBy: trackSupplier">
                        <tr class="supplierGroup" [class.supplierGroup--local]="group.bestOffer.availability === 'local'">
                          <td>
                            <button type="button" class="supplierToggle" (click)="toggleSupplier(group)"
                              [attr.aria-expanded]="expandedSupplierKeys.has(group.key)"
                              [attr.aria-controls]="'supplier-details-' + group.key">
                              <mat-icon>{{ expandedSupplierKeys.has(group.key) ? 'expand_less' : 'expand_more' }}</mat-icon>
                              <span>{{ group.providerName }}</span>
                              <span class="supplierOfferCount" [attr.title]="'Предложений по складам: ' + group.offers.length">{{ group.offers.length }}</span>
                            </button>
                            <span class="supplierWarehouse">{{ group.bestOffer.warehouseName }}</span>
                          </td>
                          <td>
                            <span class="supplierAvailability" [class.supplierAvailability--local]="group.bestOffer.availability === 'local'"
                              [class.supplierAvailability--empty]="group.bestOffer.availability === 'unavailable'">{{ supplierAvailability(group.bestOffer) }}</span>
                            <span class="supplierWarehouse">{{ group.bestOffer.cityName }}</span>
                          </td>
                          <td class="numeric"><span class="supplierQuantity" [class.supplierQuantity--empty]="group.bestOffer.quantity <= 0">{{ group.bestOffer.quantity | number: '1.0-2' }}</span></td>
                          <td class="numeric supplierPrice">{{ group.bestOffer.price !== null ? (group.bestOffer.price | number: '1.2-2') : '—' }}</td>
                        </tr>
                        <tr class="supplierDetails" *ngIf="expandedSupplierKeys.has(group.key)">
                          <td colspan="4">
                            <div [id]="'supplier-details-' + group.key">
                              <table class="supplierWarehouseTable" [attr.aria-label]="'Склады поставщика ' + group.providerName">
                                <thead><tr><th scope="col">Склад</th><th scope="col">Наличие / город</th><th scope="col" class="numeric">Кол-во</th><th scope="col" class="numeric">Закупка, грн</th></tr></thead>
                                <tbody>
                                  <tr *ngFor="let offer of group.offers">
                                    <td>{{ offer.warehouseName }}</td>
                                    <td><span class="supplierAvailability" [class.supplierAvailability--local]="offer.availability === 'local'"
                                      [class.supplierAvailability--empty]="offer.availability === 'unavailable'">{{ supplierAvailability(offer) }}</span><span class="supplierWarehouse">{{ offer.cityName }}</span></td>
                                    <td class="numeric"><span class="supplierQuantity" [class.supplierQuantity--empty]="offer.quantity <= 0">{{ offer.quantity | number: '1.0-2' }}</span></td>
                                    <td class="numeric supplierPrice">{{ offer.price !== null ? (offer.price | number: '1.2-2') : '—' }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
                <ng-template #emptySuppliers><div class="emptyStock"><mat-icon>local_shipping</mat-icon><span>Нет данных о наличии у поставщиков</span></div></ng-template>
              </section>
            </div>
          </ng-template>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label><mat-icon>compare_arrows</mat-icon><span>Аналоги</span></ng-template>
          <ng-template matTabContent>
            <div class="workspacePane analoguesPane">
              <app-analogue-panel-v2
                [productId]="currentProduct.id"
                [productTitle]="currentProduct.description"
                [embedded]="true"
                [cardMode]="true"
              ></app-analogue-panel-v2>
            </div>
          </ng-template>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label><mat-icon>tune</mat-icon><span>Свойства и коды</span></ng-template>
          <ng-template matTabContent>
            <div class="workspacePane detailsGrid">
              <section class="detailSection">
                <h2><mat-icon>tune</mat-icon>Свойства</h2>
                <app-properties-manager [product]="currentProduct"></app-properties-manager>
              </section>
              <div class="detailColumn">
                <section class="detailSection">
                  <h2><mat-icon>qr_code_2</mat-icon>Штрих-коды</h2>
                  <app-barcodes [product]="currentProduct"></app-barcodes>
                </section>
                <section class="detailSection">
                  <h2><mat-icon>pin</mat-icon>Дополнительные артикулы</h2>
                  <app-article-list [product]="currentProduct"></app-article-list>
                </section>
              </div>
            </div>
          </ng-template>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label><mat-icon>language</mat-icon><span>Описание и публикация</span></ng-template>
          <ng-template matTabContent>
            <div class="workspacePane publicationGrid">
              <section class="detailSection descriptionSection">
                <div class="paneHeading"><h2>Расширенное описание</h2><span>Сохраняется вместе с карточкой</span></div>
                <div class="descriptionFields compactFields" [formGroup]="productForm">
                  <mat-form-field appearance="outline">
                    <mat-label>Описание</mat-label>
                    <textarea matInput rows="7" formControlName="description_long"></textarea>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Описание укр</mat-label>
                    <textarea matInput rows="7" formControlName="description_long_ua"></textarea>
                  </mat-form-field>
                </div>
              </section>
              <div class="detailColumn">
                <section class="detailSection">
                  <h2><mat-icon>folder_open</mat-icon>Папки</h2>
                  <app-product-folders [product]="currentProduct"></app-product-folders>
                </section>
                <section class="detailSection">
                  <h2><mat-icon>language</mat-icon>Ссылки на маркетплейсы</h2>
                  <app-product-eshop-links [product]="currentProduct"></app-product-eshop-links>
                </section>
                <section class="detailSection">
                  <h2><mat-icon>manage_search</mat-icon>Поисковые ключи<span class="tabCount">{{ searchKeysCount }}</span></h2>
                  <app-search-key-manager [product]="currentProduct"></app-search-key-manager>
                </section>
              </div>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label><mat-icon>bar_chart</mat-icon><span>Продажи и запас</span></ng-template>
          <ng-template matTabContent>
            <div class="workspacePane">
              <app-product-sales
                [productId]="currentProduct.id"
                [period]="salesPeriod"
                [productUnit]="currentProduct.qty || 'шт.'"
                [minimumStockChanges]="minimumStockChanges"
                (minimumStockSaved)="minimumStockSaved($event)"
              ></app-product-sales>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </section>
  </ng-container>

  <ng-template #loadingState>
    <div class="loadingState" *ngIf="loadingProduct; else emptyState" role="status" aria-busy="true">
      <div class="loadingHeading"><mat-spinner diameter="20"></mat-spinner><strong>Загружаем карточку товара…</strong></div>
      <div class="skeletonPanel" aria-hidden="true">
        <div class="skeletonImage"></div>
        <div class="skeletonFields"><div></div><div></div><div></div></div>
      </div>
    </div>
    <ng-template #emptyState>
      <div class="unavailableState" role="alert">
        <mat-icon>inventory_2</mat-icon>
        <h2>Карточка товара недоступна</h2>
        <p>{{ loadError || 'Не удалось получить данные товара' }}</p>
        <button mat-stroked-button color="primary" (click)="retryLoading()"><mat-icon>refresh</mat-icon>Повторить загрузку</button>
      </div>
    </ng-template>
  </ng-template>
</div>
